import React from 'react';
import PropTypes from 'prop-types';

import { branch } from 'baobab-react/higher-order';

import Block from '@components/common/block';
import Dropdown from '@components/common/dropdown';

import BLOCKS from '@store/blocks';
import { PARAM_CHANGE } from '@store/actions';

import styles from './index.module.css';

const MODES_NAMES = [
  { title: 'Testing' },
  { title: 'Site History' },
  { title: 'Visual Recon' },
];

function ModeBlock(props) {
  return (
    <Block className={styles.block} header='Mode'>
      <Dropdown
        value={props.value}
        config={{ header: '', items: MODES_NAMES }}
        onChange={props.dispatch.bind(this, PARAM_CHANGE, BLOCKS.MODE.VALUE)}
      />
    </Block>
  );
}

ModeBlock.propTypes = {
  value: PropTypes.number.isRequired,
};

export default branch(
  {
    value: BLOCKS.MODE.VALUE,
  },
  ModeBlock,
);
